import PreviewProfile from './PreviewProfile';
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
    topics: state.topics.data,
    token: state.user.token,
});

export default connect(mapStateToProps)(PreviewProfile);
